export default __webpack_public_path__ + "static/media/meridian.2ad4cede.svg";